import React, { FC, memo } from 'react';
import { CreditNotesTable } from './CreditNotesTable';
import { TableFilterContextProvider } from 'features/TableFilter';

export const CreditNotesPage: FC = memo(() => {
  return (
    // TO DO: add tabs to show personal credit notes (refunds from our side)
    <TableFilterContextProvider>
      <CreditNotesTable />
    </TableFilterContextProvider>
  );
});

/*
  TO DO:
  Extend Personal invoices:
  + Add Vat amount and discount amount to invoiceItems
  + Add new invoiceItem type "Debt" (UPD: use Penalty type in close contract)
  + Create migration to add Vat amount and discount amount to existed invoiceItems
  + Extend Creation of Personal invoices to support multiple invoiceItems
  + In close contract logic (buss-core) extend personal invoice info to support invoiceItems
  + In buss-core create extended personal invoice after close contract logic
  + Buss-api update issue personal invoice endpoint end dto
  + Update invoice card on UI to show descriptions of invoiceItems
*/

/*
  TO DO:
  Credit notes refactor:
  + Add creditNoteItems (Same as Invoice Item)
  Create migration to add creditNoteItems to existed creditNotes, migrate warehouse, currency
  + Add Vat amount to creditNoteItems
  + Credit invoice modal (extend to support creditNoteItems)
  Create personal credit notes (backend + front) + add support of creditNoteItems
  + Credit payment (backend): add default creditNoteItem
  + Close contract update to support creditNoteItems
  Income stat refactor
  User balance refund action (create personal credit note with balance-refund type)
  Refund refactor to support credit notes
  Credit note card (same as Invoice card with creditNoteItems)
  Credit note PDF update (to support creditNoteItems)
  Credit note Email update (to support creditNoteItems)
*/

/*
  TO DO:
  Personal credit notes: 
  Second tab, same endpoint but with other creditNoteTypes in filter (PersonalCreditNoteType)
  Same filters but with other creditNoteTypes
  Add mark-as-refunded action (after backend update)
  Add export (after backend update ?)
  Create Personal credit note modal (user page) (add creditNoteItems as well) (with Vat)
  Add personal credit notes to user Profile (same as Personal Invoices) (maybe only for admin ?)
*/
